import useExperiment from 'hooks/useExperiment';
import { ExperienceSource } from 'model/IExperience';
import React from 'react';
import { experienceDuration } from 'utils/ExperienceFormattingHelper';
import {
  getExperienceAdvertisedPricePerPerson,
  getExperiencePricePerPerson,
} from 'utils/experiencePerPersonPrice';
import { useCurrencyContext } from '~/context/CurrencyContext';

import ExperienceCardLabels from './ExperienceCardLabels';
import ExperienceItemDetailsBottom from './ExperienceItemDetailsBottom';

const CSS = require('./ExperienceItemDetails.module.scss');

interface ExperienceItemProps {
  experience: ExperienceSource;
  nrOfAdults: number;
  nrOfChildren: number;
  analyticsCategory: string;
  useAdvertisedPrice?: boolean;
}

function ExperienceItemDetails({
  experience,
  nrOfAdults,
  nrOfChildren,
  useAdvertisedPrice,
}: ExperienceItemProps) {
  const { state } = useCurrencyContext();
  const roundingExperiment = useExperiment('roundedPriceCards');
  const roundPrice = roundingExperiment.assignedVariant === 1;

  const price = useAdvertisedPrice
    ? getExperienceAdvertisedPricePerPerson(experience, state.currency, {
        roundPrice,
      })
    : getExperiencePricePerPerson(
        experience,
        nrOfAdults,
        nrOfChildren,
        state.currency,
        {
          roundPrice,
        },
      );

  return (
    <div className={CSS.ExperienceItemDetails}>
      <ExperienceItemDetailsBottom
        rating={experience?.aggregates?.average_rating}
        nrOfReviews={
          experience?.reviews_count ?? experience?.aggregates?.reviews_count
        }
        price={price}
        duration={experienceDuration(experience)}
      />
      <ExperienceCardLabels
        isInstantlyConfirmed={
          experience?.attributes?.instantConfirmation === 'true'
        }
        transportMode={experience?.attributes?.transportMode}
        isFamilyFriendly={experience?.is_family_friendly}
        subCategory={experience?.attributes?.subCategory}
        hasPositiveImpact={experience.tagsDashed.includes('positive-impact')}
      />
    </div>
  );
}

export default ExperienceItemDetails;
